// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__2s1B1","withMobileMargins":"DateRangeInput_withMobileMargins__1GNvW","arrowIcon":"DateRangeInput_arrowIcon__1VUYo"};